import React, { Component } from 'react'
import { Row, Col, Card, Table, Button, Container, Form, Modal } from "react-bootstrap";
import CardLessDataTableWithSearch from '../datatables/CardLessDataTableWithSearch';
import moment from "moment";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import { withApollo } from "react-apollo";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";


class MyTaskLeadDetailsModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataClear:0
        }
    }
    componentDidUpdate(){
        if (this.props.show === true && this.state.dataClear == 0) {
            this.setState({
                dataClear:1
            })
        }
        if (this.props.show === false && this.state.dataClear == 1) {
            this.setState({ dataClear: 0 })
        }

    }
    render() {

        console.log("mnnnnnnnnnnnnn", this.props.stateData)

        return (
            <Modal
                {...this.props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
            >
                <Modal.Header closeButton>
                    <Modal.Title className="modal-title">Leads Details</Modal.Title>
                </Modal.Header>
                <Container fluid>
                    <Modal.Body className="p-4">
                        {/* <Row>
                            <Col lg={12} md={12} sm={12} className='mt-3'>

                                {
                                    this.props.stateData.myTaskrowData  ? (

                                        <CardLessDataTableWithSearch
                                            parentData={this.tableData(this.props.stateData.myTaskrowData)}
                                            particlecolumns={this.articlecolumns}
                                            name="attendance"
                                        />

                                    ) : (
                                        <Col ls={12} md={12} sm={12}>
                                            <h4 className='mt-3 text-center'><span className="text-danger"> * </span> No data available</h4>
                                        </Col>
                                    )
                                }
                            </Col>
                        </Row> */}
                        <h5 className='text-center mb-5' >Lead Form Details</h5>
                        {
                            this.props.stateData.fieldsData.length > 0 ? (
                                <Form>
                                    <Form.Row>
                                        {this.props.stateData.fieldsData.map((item) =>
                                            item.form_fields_id == '8' ? (
                                                <Form.Group as={Col} lg={6} md={12} sm={12} controlId="SelectBranch" key={item.id}>
                                                    <Form.Label className="font-weight-bold">{item.form_field_name}</Form.Label>
                                                    <Form.Control as="textarea" rows={3} value={item.value} disabled />
                                                </Form.Group>
                                            ) : (
                                                <Form.Group as={Col} lg={6} md={12} sm={12} controlId="SelectBranch" key={item.id}>
                                                    <Form.Label className="font-weight-bold">{item.form_field_name}</Form.Label>
                                                    <Form.Control as="input" name="branch" value={item.value} disabled />
                                                </Form.Group>
                                            )
                                        )}
                                    </Form.Row>
                                </Form>

                            ) : (
                                <div className='text-center'>
                                    <span className="spinner-border spinner-border-sm"></span>
                                </div>
                            )
                        }

                    </Modal.Body>
                </Container>

            </Modal>)
    }
}
export default withRouter(withApollo(
    (MyTaskLeadDetailsModal))
);
